module.exports = __webpack_public_path__ + "static/img/骷髅.1306507.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/骷髅.png
// module id = Q/Zg
// module chunks = 2